export const EVENT_NAME = {
    CHECKOUT_INITIATED: "TD_Flow"
};

export const EVENT_DATA = {
    CHECKOUT_INITIATED: {
        eventLabel: "Yes",
        eventAction: "TD_Flow",
        event: "checkout",
        eventCategory: "checkout_initiated"
    }
};
